export default __webpack_public_path__ + "static/media/Category-23.e495a59d.jpg";